/* eslint-disable import/max-dependencies */
import React from "react";
import {
  AppNavSidebar as AppNavSidebarComponent,
  AppNavSidebarAdditionalComponent,
  AppNavSidebarMenuComponent as Menu,
  ManagerInfo,
  OutstandingBalanceInfo,
  UserInfo,
  withState,
} from "@fas/cpa-cabinet-ui";
import { useTheme, withStyles } from "@mui/styles";
import { useManagerInfo } from "@fas/cpa-state-manager/redux/hooks";
import { Box, useMediaQuery } from "@mui/material";
import { TabletManagerInfo } from "@fas/cpa-cabinet-ui/lib/ManagerInfo/ManagerInfo";
import OutstandingBalanceIcon from "../../icons/OutstandingBalanceIcon";
import { useOutstandingBalance } from "../../hooks";
import {
  managerInfoStyles,
  navBarMenuComponentStyles,
  outstandingBalanceStyles,
  userInfoStyles,
  appNavSidebarStyles,
} from "../../styles";
import links from "./links";
import { RenderMediaQueryComponent } from "../../utils";
import tabletManagerInfo from "../../styles/tabletManagerInfo";
import HelpUkraineBanner from "../Dashboard/HelpUkraineBanner";
import { useLocalStorage } from "../../hooks/useStorage";
import { useUserInfo } from "../../hooks/useUserInfo";
import type { DefaultTheme } from "../../themes";

const StyledAppNavSidebarComponent = withStyles(appNavSidebarStyles)(
  AppNavSidebarComponent
);
const StyledMenu = withStyles(navBarMenuComponentStyles)(Menu);
const User = withStyles(userInfoStyles)(withState(UserInfo, useUserInfo));
const Manager = withStyles(managerInfoStyles)(
  withState(ManagerInfo, useManagerInfo)
);
const TabletManager = withStyles(tabletManagerInfo)(
  withState(TabletManagerInfo, useManagerInfo)
);
const OutstandingBalance = withStyles(outstandingBalanceStyles)(
  withState(OutstandingBalanceInfo, useOutstandingBalance)
);
const AdditionalComponent = withStyles({
  additionalComponent: {
    flexGrow: 1,
  },
})(AppNavSidebarAdditionalComponent);

const AdditionalComponentOpen = withStyles((theme: DefaultTheme) => ({
  additionalComponent: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  additionalComponentClose: {
    display: "none",
  },
}))(AppNavSidebarAdditionalComponent);

const Banner = withState(HelpUkraineBanner, () => {
  const [open, setOpen] = useLocalStorage<boolean>("ukrBannerModal", true);
  return {
    open,
    onClose: () => setOpen(false),
  };
});

const NavBar = () => {
  const theme = useTheme();
  const isExpand = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <StyledAppNavSidebarComponent permanentIconsVisible isOpen={isExpand}>
      <AppNavSidebarAdditionalComponent>
        <User />
      </AppNavSidebarAdditionalComponent>
      <AdditionalComponent>
        <Box data-testid="menu-sidebar">
          <StyledMenu links={links} />
        </Box>
      </AdditionalComponent>

      <AdditionalComponentOpen>
        <Banner />
      </AdditionalComponentOpen>

      <AppNavSidebarAdditionalComponent>
        <Box pl={{ md: 2 }}>
          <OutstandingBalance
            renderIcon={<OutstandingBalanceIcon name="navbar" />}
          />
          <RenderMediaQueryComponent mediaKey="sm" method="not">
            <Manager title="Personal manager" />
          </RenderMediaQueryComponent>
          <RenderMediaQueryComponent mediaKey="sm" method="only">
            <TabletManager title="Personal manager" />
          </RenderMediaQueryComponent>
        </Box>
      </AppNavSidebarAdditionalComponent>
    </StyledAppNavSidebarComponent>
  );
};

export default NavBar;
